import React, { useEffect, useRef } from 'react'
import { FBTabsType } from '../../../data/admin-data';
import { useMasterData } from '../../../hooks/api/useMasterData';
import FBTabsItem from '../../common/items/FBTabsItem';

interface FBTabsProps {
    activeTab: number
    setActiveTab: (value: number) => void
    data: FBTabsType[];
}

export default function FBTabs({ activeTab, setActiveTab, data }: FBTabsProps) {
    
    const { refetchGetAllProduct, refetchGetCategory, refetchAllPackages } = useMasterData()

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);
        
    const scrollRef = useRef<HTMLDivElement>(null);
    let isDown = false;
    let startX: number;
    let scrollLeft: number;
        
    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        isDown = true;
        startX = e.pageX - (scrollRef.current?.offsetLeft || 0);
        scrollLeft = scrollRef.current?.scrollLeft || 0;
    };
        
    const handleMouseLeave = () => {
        isDown = false;
    };

    const handleMouseUp = () => {
        isDown = false;
    };
        
    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - (scrollRef.current?.offsetLeft || 0);
        const walk = (x - startX) * 1; // scroll speed multiplier
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = scrollLeft - walk;
        }
    };

    const handleSelectedTab = (tabId: number) => {
        setActiveTab(tabId)
        if (tabId === 1){ 
            refetchGetAllProduct()
        } else if (tabId === 2){
            refetchGetCategory()
        } else if (tabId === 3){ 
            refetchAllPackages()
        } else if (tabId === 4) {
            refetchAllPackages()
        }
    }

    const order = [4, 1, 3];

    const sortedData = [...data].sort(
        (a, b) => order.indexOf(a.id) - order.indexOf(b.id)
    );

    return (
        <div className='space-x-3 justify-center items-center p-2 border-b-2'>
                <div 
                    ref={scrollRef}
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    className='overflow-x-auto flex scrollbar-hide justify-center'
                >
                {sortedData.map((tab) => (
                    <FBTabsItem
                        key={tab.id}
                        tab={tab}
                        handleSelectedTab={handleSelectedTab}
                        activeTab={activeTab}
                    />
                ))}
            </div>
        </div>
    )
}

